'use client';

import { Fragment, useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

const NavigationSelect = ({ product, gidMappings }) => {
  const router = useRouter();

  const [value, setValue] = useState('');
  const handleChange = (event) => {
    setValue('');
    router.push(`/product/${gidMappings[event.target.value].slug}`);
  };
  return (
    <Fragment>
      {product.variants?.map((variant, idx) => (
        <FormControl key={idx} fullWidth>
          <Select onChange={handleChange} value={value} displayEmpty>
            <MenuItem
              value=""
              disabled
              sx={{
                display: 'none',
              }}
            >
              <Stack direction="row" spacing={2}>
                <Typography fontWeight={600}>{variant.type}</Typography>
                <Box>{variant.selected}</Box>
              </Stack>
            </MenuItem>
            {variant.options.map((option, index) => (
              <MenuItem key={index} value={option.gid}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ))}
    </Fragment>
  );
};

export default NavigationSelect;
